export const getArtifactVersion = () => window.__ARTIFACT_VERSION__;
